import { QueryClient, QueryCache } from '@tanstack/react-query';

import { HTTPError } from '@vestigas/data';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry(failureCount, error) {
        if (
          error instanceof HTTPError &&
          [401, 403, 422].includes(error?.response?.status)
        ) {
          // Don't retry if the request is unauthorized or invalid
          return false;
        }

        // Retry up to 5 times if needed
        return failureCount <= 5;
      },
    },
  },
  queryCache: new QueryCache({
    onError(error, query) {
      // TODO: why do we have this in its current form? this duplicates the error handling in the queryFn; should we restrict this to certain cases?
      // if (error.message) {
      //   console.error(`Error message: ${error.message}`);
      // }
      // ToastService.error(`Something went wrong: ${error.message}`);
    },
  }),
});
